import React, { Fragment } from 'react';
import { ArcaHttpClientPageDetails } from '../../../code/ArcaHttpClientPageDetails.js';
import { ArcaComponent } from '../../pages/ArcaComponent.js';
import { PageDetails } from './PageDetails.jsx';

export class Testimonials extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            details: null
        };
    }

    componentDidMount() {
        ArcaHttpClientPageDetails.GetListAsync('Testimonials',
            (details => this.setState({ details: details })),
            (msg) => alert(msg));
    }

    render() {
        const { details } = this.state;

        return (
            <Fragment>
                <h1 className='centerText'>Testimonials</h1>
                {details
                    ? <PageDetails pageListDetails={details} />
                    : 'Page is Loading'}
            </Fragment>
        );
    }
}
